import { render, staticRenderFns } from "./AddTariff.vue?vue&type=template&id=eed4e166&scoped=true&"
import script from "./AddTariff.vue?vue&type=script&lang=js&"
export * from "./AddTariff.vue?vue&type=script&lang=js&"
import style0 from "./AddTariff.vue?vue&type=style&index=0&id=eed4e166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed4e166",
  null
  
)

export default component.exports